import Vue from 'vue';
import axios from 'axios';
import VueAxios from 'vue-axios';
//const baseURL = 'http://localhost/vueexamplerestservice/public/api/auth';
//const baseURL = 'http://piraguillarestservice.habanacompostela.com/api/auth';
//const baseURL = 'http://canoerestservice2.habanacompostela.com/api/auth';
const baseURL = 'https://alvapy.com/canoeServices/public/api/auth';

axios.defaults.baseURL = baseURL;
Vue.use(VueAxios, axios);

